<script lang='ts'>
    import {SelectSlider} from "@/Common";
    import { SpecificityTypes, specificityThreshold } from "@/Common/constants";

    export let specificity: SpecificityTypes
    export let disabled = false
    export let onInput: () => void = () => {}

    let specificities = Object.values(SpecificityTypes)
    let specificityIndex = specificities.indexOf(specificity)
</script>

<div class="flex flex-col gap-1 items-center">
    <SelectSlider min=0 max=2 step=1 {disabled}
        bind:value={specificityIndex} 
        on:input={() => {
            specificity = specificities[specificityIndex]
            onInput()
        }} 
    />
    <span class="text-center">
        {specificity}
        <br/>
        <span class="text-sm text-slate-500">
            {specificityThreshold[specificity]}
        </span>
    </span>
</div>